import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOut } from '@fortawesome/pro-solid-svg-icons';
import { useAppDispatch } from '@/_store/hooks';
import styles from './styles.module.scss';
import { authLogout } from '@/_store/modules/auth';

function LogoutButton() {
  const dispatch = useAppDispatch();

  const onClickLogout = () => {
    dispatch(authLogout());
  };

  return (
    <button onClick={onClickLogout} className={styles.logout}>
      <FontAwesomeIcon data-testid="exit-icon" icon={faSignOut} size="lg" />
      Sair
    </button>
  );
}

export { LogoutButton };
